import $ from 'jquery'

/**
 * WAI-ARIA Tabs keyboard support (APG):
 * - Tab moves focus into/out of the tab list (only the selected tab is in tab order)
 * - Arrow keys move selection + focus between tabs
 * - Home / End jump to first / last tab
 */
function activateTab( $tab, $tabs, $root, { focus = false } = {} ) {
  const targetId = $tab.data( 'target' )

  $tabs
    .removeClass( 'active' )
    .attr({
      'aria-selected': 'false',
      tabindex: '-1',
    })

  $tab
    .addClass( 'active' )
    .attr({
      'aria-selected': 'true',
      tabindex: '0',
    })

  $root
    .find( '.js-tab-content' )
    .removeClass( 'active' )
    .attr( 'hidden', true )

  $root
    .find( `#${targetId}` )
    .addClass( 'active' )
    .removeAttr( 'hidden' )

  if ( focus ) {
    $tab.trigger( 'focus' )
  }
}

$( document ).on( 'click', '.js-tabs .js-tab-item', function ( e ) {
  e.preventDefault()
  const $tab = $( this )
  const $root = $tab.closest( '.js-tabs' )
  const $tabs = $root.find( '.js-tab-item' )
  activateTab( $tab, $tabs, $root )
})

$( document ).on( 'keydown', '.js-tabs .js-tab-item', function ( e ) {
  const navigationKeys = [ 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End' ]
  if ( ! navigationKeys.includes( e.key ) ) {
    return
  }

  const $tab = $( this )
  const $root = $tab.closest( '.js-tabs' )
  const $tabs = $root.find( '.js-tab-item' )
  const tabs = $tabs.get()
  const index = tabs.indexOf( this )
  if ( index < 0 ) {
    return
  }

  let next = index
  switch ( e.key ) {
    case 'ArrowLeft':
    case 'ArrowUp':
      next = index === 0 ? tabs.length - 1 : index - 1
      break
    case 'ArrowRight':
    case 'ArrowDown':
      next = index === tabs.length - 1 ? 0 : index + 1
      break
    case 'Home':
      next = 0
      break
    case 'End':
      next = tabs.length - 1
      break
  }

  e.preventDefault()
  activateTab( $( tabs[ next ] ), $tabs, $root, { focus: true } )
})
